import PropTypes from "prop-types";

import { Paper, Stack, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

import { formatNumber } from "@/features/shared";
import { ProductVariantNameCell } from "@/features/ui";

export const ProductVariantsSection = ({
  customerClaimProductVariants,
  warehouse,
}) => {
  if (!customerClaimProductVariants?.length) {
    return null;
  }

  const columns = [
    {
      field: "name",
      headerName: "Produk Varian",
      flex: 5,
      renderCell: ({ row: { name, sku } }) => (
        <ProductVariantNameCell
          name={name}
          sku={sku}
          linkToStock
          warehouseId={warehouse?.id}
          warehouseName={warehouse?.name}
        />
      ),
    },
    {
      field: "quantity",
      headerName: "Qty",
      type: "number",
      flex: 1,
      valueFormatter: (value) => formatNumber(value),
    },
    {
      field: "note",
      headerName: "Catatan",
      flex: 1.5,
      valueGetter: (_, row) => row.note || "-",
    },
  ];

  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Stack spacing={2}>
        <Typography variant="subtitle1">Produk Varian</Typography>
        <DataGrid
          getRowHeight={() => "auto"}
          columns={columns}
          rows={customerClaimProductVariants}
          disableRowSelectionOnClick
          initialState={{
            sorting: {
              sortModel: [{ field: "name", sort: "asc" }],
            },
          }}
        />
      </Stack>
    </Paper>
  );
};

ProductVariantsSection.propTypes = {
  customerClaimProductVariants: PropTypes.array.isRequired,
  warehouse: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
};
